import { render, staticRenderFns } from "./ManageEntityRecipients.vue?vue&type=template&id=ce9fbffa&scoped=true"
import script from "./ManageEntityRecipients.vue?vue&type=script&lang=js"
export * from "./ManageEntityRecipients.vue?vue&type=script&lang=js"
import style0 from "./ManageEntityRecipients.vue?vue&type=style&index=0&id=ce9fbffa&prod&lang=css"
import style1 from "./ManageEntityRecipients.vue?vue&type=style&index=1&id=ce9fbffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce9fbffa",
  null
  
)

export default component.exports